import { render, staticRenderFns } from "./addScreen.vue?vue&type=template&id=6a34b7a8&scoped=true&"
import script from "./addScreen.vue?vue&type=script&lang=js&"
export * from "./addScreen.vue?vue&type=script&lang=js&"
import style0 from "./addScreen.vue?vue&type=style&index=0&id=6a34b7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34b7a8",
  null
  
)

component.options.__file = "addScreen.vue"
export default component.exports